export default __webpack_public_path__ + "static/media/Aceptación Manual ABC Estilo Militar Colombiano.bc30fbbb.docx";